<section class="dashboard-page">

  <!-- Cabeçalho -->

  <header class="page-header">

    <div>
      <span class="eyebrow">
        Visão geral
      </span>

      <h1>Dashboard</h1>

      <p>
        Acompanhe o faturamento, os pedidos e o desempenho
        do seu restaurante.
      </p>
    </div>

    <button
      type="button"
      class="refresh-button"
      [disabled]="loadingDashboard || !restaurantId"
      (click)="loadDashboard()">

      <span
        class="refresh-icon"
        [class.rotating]="loadingDashboard">

        ↻
      </span>

      {{
        loadingDashboard
          ? 'Atualizando...'
          : 'Atualizar dados'
      }}
    </button>

  </header>

  <!-- Mensagem de erro -->

  <div
    class="message error-message"
    *ngIf="error">

    {{ error }}
  </div>

  <!-- Filtros -->

  <section class="filter-card">

    <div class="filter-field restaurant-filter">

      <label for="dashboardRestaurant">
        Restaurante
      </label>

      <select
        id="dashboardRestaurant"
        [(ngModel)]="restaurantId"
        [disabled]="loadingRestaurants"
        (ngModelChange)="onRestaurantChange()">

        <option
          [ngValue]="null">

          Selecione um restaurante
        </option>

        <option
          *ngFor="let restaurant of restaurants"
          [ngValue]="restaurant.id">

          {{ restaurant.name }}
        </option>

      </select>

    </div>

    <div class="period-filter">

      <label>Período</label>

      <div class="period-buttons">

        <button
          type="button"
          [class.active]="selectedPeriod === 'today'"
          (click)="setPeriod('today')">

          Hoje
        </button>

        <button
          type="button"
          [class.active]="selectedPeriod === 'yesterday'"
          (click)="setPeriod('yesterday')">

          Ontem
        </button>

        <button
          type="button"
          [class.active]="selectedPeriod === '7days'"
          (click)="setPeriod('7days')">

          7 dias
        </button>

        <button
          type="button"
          [class.active]="selectedPeriod === '30days'"
          (click)="setPeriod('30days')">

          30 dias
        </button>

        <button
          type="button"
          [class.active]="selectedPeriod === 'month'"
          (click)="setPeriod('month')">

          Este mês
        </button>

        <button
          type="button"
          [class.active]="selectedPeriod === 'custom'"
          (click)="setPeriod('custom')">

          Personalizado
        </button>

      </div>

    </div>

    <div
      class="custom-period"
      *ngIf="selectedPeriod === 'custom'">

      <div class="filter-field">
        <label for="startDate">
          Data inicial
        </label>

        <input
          id="startDate"
          type="date"
          [(ngModel)]="startDate">
      </div>

      <div class="filter-field">
        <label for="endDate">
          Data final
        </label>

        <input
          id="endDate"
          type="date"
          [(ngModel)]="endDate">
      </div>

      <button
        type="button"
        class="apply-period-button"
        [disabled]="loadingDashboard"
        (click)="applyCustomPeriod()">

        Aplicar período
      </button>

    </div>

    <div
      class="current-period"
      *ngIf="dashboard.period.startDate">

      Período analisado:

      <strong>
        {{ formatFullDate(dashboard.period.startDate) }}
        até
        {{ formatFullDate(dashboard.period.endDate) }}
      </strong>

    </div>

  </section>

  <!-- Carregamento inicial -->

  <section
    class="loading-state"
    *ngIf="loadingDashboard">

    <div class="loading-spinner"></div>

    <h2>Carregando indicadores</h2>

    <p>
      Estamos preparando os dados do restaurante.
    </p>

  </section>

  <!-- Conteúdo -->

  <ng-container *ngIf="!loadingDashboard && restaurantId">

    <!-- KPIs -->

    <section class="kpi-grid">

      <article class="kpi-card revenue-card">

        <div class="kpi-top">

          <span class="kpi-icon">
            R$
          </span>

          <span class="kpi-label">
            Faturamento
          </span>

        </div>

        <strong class="kpi-value">
          {{ formatMoney(dashboard.summary.revenue) }}
        </strong>

        <span class="kpi-description">
          Pedidos entregues no período
        </span>

      </article>

      <article class="kpi-card">

        <div class="kpi-top">

          <span class="kpi-icon">
            #
          </span>

          <span class="kpi-label">
            Total de pedidos
          </span>

        </div>

        <strong class="kpi-value">
          {{ dashboard.summary.orders }}
        </strong>

        <span class="kpi-description">
          {{ dashboard.summary.finishedOrders }}
          pedido(s) entregues
        </span>

      </article>

      <article class="kpi-card">

        <div class="kpi-top">

          <span class="kpi-icon">
            TM
          </span>

          <span class="kpi-label">
            Ticket médio
          </span>

        </div>

        <strong class="kpi-value">
          {{ formatMoney(dashboard.summary.averageTicket) }}
        </strong>

        <span class="kpi-description">
          Média por pedido entregue
        </span>

      </article>

      <article
        class="kpi-card growth-card"
        [ngClass]="getGrowthClass()">

        <div class="kpi-top">

          <span class="kpi-icon">
            {{ getGrowthIcon() }}
          </span>

          <span class="kpi-label">
            Crescimento
          </span>

        </div>

        <strong class="kpi-value">
          {{ formatPercentage(
            dashboard.summary.growthPercentage
          ) }}
        </strong>

        <span class="kpi-description">
          Comparado ao período anterior
        </span>

      </article>

      <article class="kpi-card">

        <div class="kpi-top">

          <span class="kpi-icon pending-icon">
            !
          </span>

          <span class="kpi-label">
            Em andamento
          </span>

        </div>

        <strong class="kpi-value">
          {{ dashboard.summary.openOrders }}
        </strong>

        <span class="kpi-description">
          Aguardando conclusão
        </span>

      </article>

      <article class="kpi-card">

        <div class="kpi-top">

          <span class="kpi-icon canceled-icon">
            ×
          </span>

          <span class="kpi-label">
            Cancelados
          </span>

        </div>

        <strong class="kpi-value">
          {{ dashboard.summary.canceledOrders }}
        </strong>

        <span class="kpi-description">
          Pedidos cancelados no período
        </span>

      </article>

    </section>

    <!-- Sem pedidos -->

    <section
      class="empty-state"
      *ngIf="!hasOrders()">

      <div class="empty-icon">
        📊
      </div>

      <h2>Ainda não existem pedidos neste período</h2>

      <p>
        Selecione outro período ou aguarde a chegada
        dos primeiros pedidos.
      </p>

    </section>

    <!-- Gráficos -->

    <section
      class="charts-layout"
      *ngIf="hasOrders()">

      <!-- Faturamento -->

      <article class="chart-card sales-card">

        <header class="chart-header">

          <div>
            <span class="chart-eyebrow">
              Desempenho
            </span>

            <h2>Faturamento por dia</h2>

            <p>
              Evolução das receitas e da quantidade
              de pedidos.
            </p>
          </div>

        </header>

        <div
          #salesChart
          class="chart chart-large">
        </div>

      </article>

      <!-- Status -->

      <article class="chart-card status-card">

        <header class="chart-header">

          <div>
            <span class="chart-eyebrow">
              Operação
            </span>

            <h2>Pedidos por status</h2>

            <p>
              Distribuição dos pedidos no período.
            </p>
          </div>

        </header>

        <div
          #statusChart
          class="chart chart-medium">
        </div>

      </article>

      <!-- Produtos -->

      <article class="chart-card products-card">

        <header class="chart-header">

          <div>
            <span class="chart-eyebrow">
              Cardápio
            </span>

            <h2>Produtos mais vendidos</h2>

            <p>
              Ranking baseado nos pedidos entregues.
            </p>
          </div>

        </header>

        <div
          class="chart-empty"
          *ngIf="!dashboard.topProducts.length">

          Nenhum produto vendido no período.
        </div>

        <div
          #productsChart
          class="chart products-chart"
          [class.hidden-chart]="
            !dashboard.topProducts.length
          ">
        </div>

      </article>

      <!-- Tipos -->

      <article class="chart-card types-card">

        <header class="chart-header">

          <div>
            <span class="chart-eyebrow">
              Atendimento
            </span>

            <h2>Tipos de pedido</h2>

            <p>
              Entregas, retiradas e atendimento em mesa.
            </p>
          </div>

        </header>

        <div
          #typesChart
          class="chart chart-medium">
        </div>

      </article>

      <!-- Horários -->

      <article class="chart-card hours-card">

        <header class="chart-header">

          <div>
            <span class="chart-eyebrow">
              Movimento
            </span>

            <h2>Pedidos por horário</h2>

            <p>
              Identifique os horários com maior demanda.
            </p>
          </div>

        </header>

        <div
          #hoursChart
          class="chart chart-large">
        </div>

      </article>

    </section>

  </ng-container>

  <!-- Sem restaurantes -->

  <section
    class="empty-state"
    *ngIf="
      !loadingRestaurants &&
      !restaurants.length
    ">

    <div class="empty-icon">
      🍽️
    </div>

    <h2>Nenhum restaurante cadastrado</h2>

    <p>
      Cadastre um restaurante antes de acessar
      os indicadores do Dashboard.
    </p>

  </section>

</section>